import { useLayoutEffect, useRef, useMemo, useState } from 'react'
import useLayout from '#Context/Layout'
import useFiligree from './scripts/Filigree'
import useBGImages from './scripts/BGImages'

//backdrop patterns
import mobileBG from './imgs/mobileBG.jpg'
import wideBG from './imgs/wideBG.jpg'

// path patterns
import widePaths from './paths/widePaths.js'
import mobilePaths from './paths/mobilePaths.js';
flip(mobilePaths)

export default function Background() {
    // console.log('BG render')
    const { dimensions, platform, orientation } = useLayout();
    const filigree = useRef(null)
    const bgImages = useRef(null)

    //set URL for backdrop pattern
    const bgURL = useMemo(() => platform === 'mobile' ? mobileBG : wideBG, [platform])

    //setPaths for BG pattern
    const paths = useMemo(() => {
        // console.log('Bg path hook')
        switch (platform) {
        case 'desktop':
            return widePaths
        case 'mobile':
        case 'tablet':
        default:
            return mobilePaths;
        }
    }, [platform])

    useFiligree(platform, dimensions, paths, filigree)
    useBGImages(platform, dimensions, paths, bgImages)

    return (
        <>
            <div id="backdrop" style={{ height: '100dvh', width: '100vw', position: 'fixed', top: 0,
                zIndex: -4, background: `url(${bgURL}) top left/100% 100% no-repeat`
            }} >
            </div>
            <canvas ref={bgImages} id="bgImg" style={{ height: '87dvh', width: '100vw', position: 'fixed', top: '13dvh', zIndex: -3 }}></canvas>
            <canvas  ref={filigree}  style={{ height: '87dvh', width: '100vw', position: 'fixed', top: '13dvh', zIndex: -2 }}></canvas>
        </>
    )
}

//helpers
function flip(paths) {
    for (let p in paths) {
        for (let point of paths[p]) {
            point[0] = 100 - point[0]
        }
    }
}